import { X } from 'lucide-react'
import type { DetectedDienstwagen } from '../services/payslipParser'

interface Props {
  dw: DetectedDienstwagen
  index: number
  inputClass: string
  onUpdate: (field: keyof DetectedDienstwagen, value: DetectedDienstwagen[keyof DetectedDienstwagen]) => void
  onRemove: () => void
}

export default function DienstwagenCard({ dw, index, inputClass, onUpdate, onRemove }: Props) {
  return (
    <div className="col-span-2 border border-zinc-200 dark:border-zinc-700 rounded-lg p-4 space-y-3">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-zinc-700 dark:text-zinc-300">
          🚗 {dw.bezeichnung || `Fahrzeug ${index + 1}`}
        </span>
        <button
          onClick={onRemove}
          className="p-1 text-zinc-400 hover:text-red transition-colors"
          title="Fahrzeug entfernen"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-zinc-600 dark:text-zinc-400 mb-1">
            Listenpreis (BLP)
          </label>
          <div className="relative">
            <input
              type="number"
              placeholder="0"
              value={dw.listenpreis ?? ''}
              onChange={e => onUpdate('listenpreis', e.target.value === '' ? null : Number(e.target.value))}
              className={inputClass}
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 text-sm pointer-events-none">€</span>
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-zinc-600 dark:text-zinc-400 mb-1">
            GwV-Prozentsatz
          </label>
          <select
            value={dw.gwvProzent}
            onChange={e => onUpdate('gwvProzent', Number(e.target.value))}
            className={inputClass}
          >
            <option value={0.25}>0,25% (Elektro)</option>
            <option value={0.5}>0,5% (Hybrid)</option>
            <option value={1.0}>1,0% (Verbrenner)</option>
          </select>
        </div>

        <div>
          <label className="block text-xs font-medium text-zinc-600 dark:text-zinc-400 mb-1">
            Entfernung (einfach)
          </label>
          <div className="relative">
            <input
              type="number"
              placeholder="0"
              value={dw.entfernungKm ?? ''}
              onChange={e => onUpdate('entfernungKm', e.target.value === '' ? null : Number(e.target.value))}
              className={inputClass}
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 text-sm pointer-events-none">km</span>
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-zinc-600 dark:text-zinc-400 mb-1">
            Gehaltsumwandlung
          </label>
          <div className="relative">
            <input
              type="number"
              placeholder="0"
              value={dw.gehaltsumwandlung ?? ''}
              onChange={e => onUpdate('gehaltsumwandlung', e.target.value === '' ? null : Number(e.target.value))}
              className={inputClass}
            />
            <span className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-400 text-sm pointer-events-none">€</span>
          </div>
        </div>

        {dw.gwvBetrag != null && (
          <div>
            <label className="block text-xs font-medium text-zinc-600 dark:text-zinc-400 mb-1">
              GwV-Betrag (erkannt)
            </label>
            <div className="px-3 py-2 text-sm text-zinc-500 dark:text-zinc-400 bg-zinc-50 dark:bg-zinc-800 rounded border border-zinc-200 dark:border-zinc-700">
              {dw.gwvBetrag.toFixed(2)} €
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
